import { render, staticRenderFns } from "./operating-permits.vue?vue&type=template&id=867e541a&"
import script from "./operating-permits.vue?vue&type=script&lang=js&"
export * from "./operating-permits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports